import { useLocation, useSearchParams } from "react-router-dom";
import FolderProjectStructure from "views/AdminSettings/Projects/FolderProjectStructure";

const ManageFolderTemplate = () => {
  const location = useLocation();
  const { data } = location.state || {};
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  return (
    <FolderProjectStructure
      rowData={data}
      projectType={type}
      isManageFolder={true}
    />
  );
};

export default ManageFolderTemplate;
